import React, { Component } from "react";
import { Form, Input, Button, Card } from "reactstrap";
import { postData } from "../utils/fetch-requests";

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newUser: {
        email: "",
        password: "",
      },
      error: "",
    };
  }

  buildUser = (e) => {
    let newState = Object.assign({}, this.state);
    newState.newUser[e.target.id] = e.target.value;
    newState.error = "";
    this.setState(newState);
  };

  attemptLogin = () => {
    this.setState({ error: "" });
    postData("/api/user/authenticate", this.state.newUser)
      .then((res) => {
        if (res.message === "Login was successful") {
          // set JWT Token for Box and other Auth
          localStorage.setItem("authorization", res.token);
          window.location.href = "/customers";
        } else {
          this.setState({
            error: "Incorrect email or password. Please try again.",
          });
        }
      })
      .catch(() => {
        this.setState({ error: "Something went wrong. Please try again." });
      });
  };

  render() {
    return (
      <div className="d-flex h-100 justify-content-center justify-content-middle text-center">
        <div className="col-md-3" style={{ marginTop: "10%" }}>
          <Card className="p-3 card-shadow">
            <div className="align-self-center">
              <img
                src="https://cdn.rynoss.com/wp-content/themes/rynoss/assets/images/RYNOSS-logo.png"
                alt=""
              />
            </div>
            <h5 className="text-muted">Please login below.</h5>
            <div className="col-12">
              <Form>
                <Input
                  id="email"
                  className="form-control mb-1"
                  placeholder="E-mail address"
                  onChange={(event) => this.buildUser(event)}
                />
                <Input
                  id="password"
                  className="form-control mb-1"
                  placeholder="Password"
                  type="password"
                  onChange={(event) => this.buildUser(event)}
                />
              </Form>
              {this.state.error && (
                <p className="text-danger mb-1">{this.state.error}</p>
              )}
              <Button
                className="ryno-orange-bg"
                block
                onClick={() => this.attemptLogin()}
              >
                Login
              </Button>
              <a href="/forgot-password" className="d-block mt-2">
                Forgot password?
              </a>
            </div>
          </Card>
        </div>
      </div>
    );
  }
}

export default LoginPage;
